import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

// Menu dos 3 pontinhos de uma evolução geral (compartilhado entre web e mobile).
export default function GeneralEvolutionActionsMenu({
  anchorEl,
  evolution,
  onClose,
  onRectify,
  onViewRectifications,
}) {
  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem data-cy="rectify-general-evolution-btn" onClick={onRectify}>
        Retificar
      </MenuItem>
      {evolution?.rectified && (
        <MenuItem data-cy="see-general-evolution-rectifications-btn" onClick={onViewRectifications}>
          Ver Retificações
        </MenuItem>
      )}
    </Menu>
  );
}

GeneralEvolutionActionsMenu.propTypes = {
  anchorEl: PropTypes.object,
  evolution: PropTypes.shape({
    rectified: PropTypes.bool,
  }),
  onClose: PropTypes.func.isRequired,
  onRectify: PropTypes.func.isRequired,
  onViewRectifications: PropTypes.func.isRequired,
};

GeneralEvolutionActionsMenu.defaultProps = {
  anchorEl: null,
  evolution: null,
};
